export default __webpack_public_path__ + "static/media/quiz-pic-0.7313f39b.jpeg";